import { render, staticRenderFns } from "./NewBuy.vue?vue&type=template&id=55774e32&scoped=true"
import script from "./NewBuy.vue?vue&type=script&lang=js"
export * from "./NewBuy.vue?vue&type=script&lang=js"
import style0 from "./NewBuy.vue?vue&type=style&index=0&id=55774e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55774e32",
  null
  
)

export default component.exports